import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type IndiaState = {
    id: Uuid;
    name: string;
    zoneId: Uuid;
};

export const indiaStateValidator: zod.ZodType<IndiaState> = zod.strictObject({
    id: uuidZodValidator,
    name: zod.string(),
    zoneId: uuidZodValidator,
});
